import type { ReactNode } from 'react';

export type TagTone = 'default' | 'primary' | 'ok' | 'warn' | 'danger' | 'muted' | 'school' | 'brand';

export interface TagProps {
  tone?: TagTone;
  /** 悬浮说明（例如「待归类」为什么要显示） */
  title?: string;
  children: ReactNode;
}

/** 状态/技能/学校等小标签。所有 tone 的文字对比度均 ≥ 4.5:1（见 global.css 注释）。 */
export function Tag({ tone = 'default', title, children }: TagProps) {
  const classes = ['tag', tone === 'default' ? '' : `tag-${tone}`].filter((item) => item.length > 0).join(' ');
  return (
    <span className={classes} title={title}>
      {children}
    </span>
  );
}